export default {
  fillInOrder: 'Wypełnij zamówienie agenta zakupowego',
  inputTips: "(kolumny oznaczone <span style='color: red'>*</span> są wymagane)",
  process: {
    first: 'Wypełnij zamówienie i wyślij',
    second: 'Zapłać za produkt i opłatę za dostawę krajową',
    three: 'Poczekaj, aż Twój produkt dotrze do magazynu',
  },
  productInfo: 'Informacje o produkcie',
  productInfoTips:
    'Wszystkie produkty dostępne w usłudze agenta zakupowego wyświetlane na acbuy są produktami pobranymi z zewnętrznych platform zakupowych i nie są sprzedawane bezpośrednio przez acbuy. W związku z tym, w przypadku jakichkolwiek problemów z naruszeniem praw, wszelką odpowiedzialność ponoszą odpowiedni sprzedawcy na platformie zewnętrznej, podczas gdy acbuy nie ponosi żadnej odpowiedzialności powiązanej, dodatkowej ani solidarnej.',
  fees: 'Opłaty',
  feeStandard: 'Standardy opłat',
  feeStandardTips:
    'W przypadku zamówienia agenta zakupowego złożonego na tej stronie, jeśli produkt pochodzi z platform zewnętrznych, takich jak Kongfuzi Used Books, Xiaohongshu i Youzan itp., istnieje możliwość, że produkt nie będzie mógł zostać zakupiony. Produkt jest związany z ryzykiem wysyłki lub może zostać naliczona dodatkowa opłata serwisowa. Rzeczywista opłata serwisowa musi zostać zweryfikowana przez agenta. Więcej szczegółów znajdziesz w "Centrum pomocy - Standardy opłat za usługi agenta zakupowego zewnętrznych platform".',
  link: 'Link',
  name: 'Nazwa',
  remark: 'Uwagi',
  unitPrice: 'Cena jednostkowa (CNY)',
  qty: 'Ilość',
  goodsAttr: 'Specyfikacje lub materiał',
  chinaPostage: 'Opłata za wysyłkę (CNY)',
  holder: {
    inputUrl: 'Proszę wkleić URL produktu',
    inputName: 'Proszę wprowadzić nazwę produktu (do 100 znaków)',
    inputAttr: 'Proszę wprowadzić specyfikację produktów',
    inputRemark:
      'Jeśli przedmiot ma kilka wzorów, rozmiarów, kolorów itp., proszę określić czego potrzebujesz na podstawie opisu klasyfikacji na stronie produktu. Jeśli kupujesz ten sam produkt, ale z różnymi specyfikacjami, proszę rozdzielić zamówienie.',
    contactName: 'Proszę wprowadzić swoje dane kontaktowe',
    contactEmail: 'Proszę wpisać swój kontaktowy adres e-mail',
    contactPhone: 'Proszę wprowadzić swój numer telefonu kontaktowego',
  },
  other: 'Inne (opcjonalne)',
  productImg: 'Zdjęcia produktu',
  fareTip:
    'Opłata za wysyłkę krajową do naszego magazynu (jeśli nie jesteś pewien, wpisz 0, agent zweryfikuje i zainicjuje płatność)',
  customizedLogisticsForm: 'Dostosowany formularz zgłoszeń logistycznych',
  submitInfo: 'Przesyłaj informacje o produkcie',
  customizedProcess: {
    first: 'Wypełnij zamówienie',
    second: 'Przesyłaj informacje o produkcie',
    three: 'Poczekaj, aż acbuy skontaktuje się z Tobą',
  },
  deliveryAddress: 'Adres dostawy',
  contactDetail: 'Dane kontaktowe',
  contactName: 'Nazwa kontaktowa',
  contactPhone: 'Telefon kontaktowy',
  contactEmail: 'Kontakt Email',
  customizedLogisticsInformation: 'Dostosowane informacje logistyczne',
  fromWarehouse: 'Z magazynu',
  manuallyFill: 'Ręcznie wypełniać informacje o produkcie',
  contactInfoTips1:
    '·Aby lepiej Ci służyć, prosimy o wypełnienie formularza prawdziwie i szczegółowo. W ciągu trzech dni roboczych po złożeniu wniosku, dedykowany personel skontaktuje się z Tobą. ',
  contactInfoTips2:
    '·W przypadku paczek poniżej 30KG klientom zaleca się wybór dostawy logistycznej online.',
  contactInfoTips3:
    '·Usługi niestandardowe obejmują tylko transport logistyczny, a towary są sprawdzane tylko pod kątem wyglądu, a szczegółowa kontrola jakości towarów nie jest przeprowadzana.',
  myWarehouse: 'Mój magazyn',
  itemName: 'Nazwa elementu',
  volume1: 'Wymiary paczki po zapakowaniu',
  volume: 'Objętość(cm)',
  weight: 'Waga',
  length: 'Długość',
  width: 'Szerokość',
  height: 'Wysokość',
  warehouseItem: 'Przedmiot magazynu',
  manuallyItem: 'Ręczny element',
  submitSuccess: 'Indywidualny wniosek logistyczny złożony pomyślnie',
  submitMsg: 'Skontaktujemy się z Tobą jak najszybciej, prosimy o cierpliwość.',
  inputProductMsg: 'Proszę wprowadzić informacje o produkcie',
  selectZone: 'Proszę wybrać kod obszaru numeru telefonu kontaktowego',
  productName: 'Link do produktu lub nazwa',
}
